import { render, staticRenderFns } from "./CoPas.vue?vue&type=template&id=7878fb0c&"
import script from "./CoPas.vue?vue&type=script&lang=js&"
export * from "./CoPas.vue?vue&type=script&lang=js&"
import style0 from "./CoPas.vue?vue&type=style&index=0&id=7878fb0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports